import React from 'react';

const steps = ['Grade', 'Diagnostic', 'Placement'];

function OnboardingShell({
  step,
  audience,
  children
}) {
  return (
    <main className="page-shell">
      <section className="mx-auto max-w-3xl overflow-hidden rounded-[22px] border border-[#e3e4de] bg-white shadow-[0_18px_50px_rgba(37,48,45,0.07)]">
        <header className="border-b border-[#e3e4de] px-6 py-6 sm:px-9">
          <div className="flex items-center justify-between gap-4">
            <span className="eyebrow">{audience}</span>
            <span className="text-xs font-semibold text-[#6c7773]">
              Step {step} of 3
            </span>
          </div>

          <div
            aria-label="Onboarding progress"
            className="mt-5 grid grid-cols-3 gap-2"
          >
            {steps.map((label, index) => {
              const number = index + 1;
              const active = number <= step;

              return (
                <div className="flex items-center gap-2" key={label}>
                  <span
                    className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ${
                      active
                        ? 'bg-[#7c3aed] text-white'
                        : 'bg-[#f0f0ec] text-[#949b96]'
                    }`}
                  >
                    {number}
                  </span>
                  <span
                    className={`hidden text-xs font-semibold sm:block ${
                      active ? 'text-[#24302d]' : 'text-[#949b96]'
                    }`}
                  >
                    {label}
                  </span>
                </div>
              );
            })}
          </div>
        </header>

        <div className="px-6 py-8 sm:px-9 sm:py-10">
          {children}
        </div>
      </section>
    </main>
  );
}

export default OnboardingShell;